import React, { useState, useEffect } from "react";
import PropTypes, { func } from 'prop-types';
import Offcanvas from 'react-bootstrap/Offcanvas'
import OptionAppMenu from "./OptionAppMenu";
import SectionAhorro from "./SectionAhorro";
import useMediaQuery from "app/hooks/useMediaQuery";
import './AppMenu.css';

TopMenuItem.propTypes = {
    name:PropTypes.string,
    section:PropTypes.number,
    setActiveSection:func,
    activeSection:PropTypes.number,
    active:PropTypes.bool,
    iconUrl:PropTypes.string
};

function TopMenuItem({ 
    name="", 
    section=0, 
    setActiveSection=()=>{},
    activeSection=0,
    active=false,
    iconUrl="",
    ...props 
}) {
  const is4K = useMediaQuery('(min-width: 3840px)');
    const [show, setShow] = useState(false);

    useEffect(() => {
        show ? setActiveSection(section) : setActiveSection(0)
        // eslint-disable-next-line
     }, [show]);
  
    const handleClose = () => {        
        setShow(false);
    }
    
    const toggleShow = () => {
        setShow((s) => !s);        
    }

    const showSectionMenu=(section, title)=>{
      if(section === 1){ return (<SectionAhorro title={title} setShow={setShow} sectionIcon={iconUrl}/>)}     
    }
  
    return (
      <>
        <OptionAppMenu
            name={name}
            title={name}
            url="/"
            onClick={toggleShow}
            imgSrc={iconUrl}
        />
            {active &&
                <Offcanvas
                    backdrop={false}
                    className={`${is4K && "offcanvas-4K"}`} 
                    show={show} 
                    onHide={handleClose} 
                    style={
                        {
                            backgroundColor:"#001a70", 
                            color:"white", 
                            marginTop:"50px",
                            paddingLeft:"4px", 
                            paddingRight:"4px"
                        }
                    }
                    {...props}
                > 
                <Offcanvas.Body >
                    {showSectionMenu(section, name)}
                </Offcanvas.Body>
                </Offcanvas>
            }
      </>
    );
  }
  
  export default TopMenuItem;